export default "__VITE_ASSET__a621164e__"